import { useSearchParams } from 'next/navigation';

import { CategoryWiseProductsResponse } from '@/types/Category';

export const useParseCategoryForAlgolia = (categoryDetails?: CategoryWiseProductsResponse) => {
  const searchParams = useSearchParams();
  const catPath = categoryDetails?.attributes?.Path || '';
  const catDepth = categoryDetails?.attributes?.Depth || 0;

  const itemCodesParam = searchParams.get('itemCodes');
  const itemCodes = itemCodesParam?.split(',') ?? [];
  const itemCodeFilters = itemCodes.map(ic => `objectID:${ic} OR GMCode:${ic} OR ParentGMCode:${ic}`).join(' OR ');
  const priceParams = searchParams.get('price')?.trim();
  const priceFilters = priceParams?.length ? `priceNumber:${decodeURI(priceParams)}` : '';
  const ratingParam = searchParams.get('rating')?.trim();
  const ratingFilters = ratingParam?.length ? `rating:${decodeURI(ratingParam)}` : '';
  const querySearchParams = searchParams.get('searchTerm')?.trim() || searchParams.get('query')?.trim();
  const searchQuery = querySearchParams?.length ? decodeURIComponent(querySearchParams) : undefined;

  const categoryName = catPath?.includes('Issues')
    ? (
        catPath
          ?.split?.('>')
          ?.map?.(item => item.trim())
          ?.slice?.(-3) || []
      ).join(' > ')
    : catDepth == 7
    ? (
        catPath
          ?.split?.('>')
          ?.map?.(item => item.trim())
          ?.slice?.(-2) || []
      ).join(' > ')
    : categoryDetails?.attributes?.Name;

  const shouldFetchParentId = catDepth >= 7 && !catPath.includes('Issues');

  return {
    catDepth,
    catPath,
    categoryName,
    shouldFetchParentId,
    itemCodeFilters,
    priceFilters: '',
    ratingFilters: '',
    searchQuery,
  };
};
